import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/message_preferences_pb';

export enum CommunicationStyles {
  Informal = 'informal',
}

export enum CommunicationFlags {
  HideDetailsBlock = 'hide_details_block',
  HideFooterPhone = 'hide_footer_phone',
  HideFooterEmail = 'hide_footer_email',
}

export default class MessageSettings {
  id: number = 0;

  defaultLocale: string = '';

  enabledLocales: string[] = [];

  communicationStyles: string[] = [];

  communicationFlags: string[] = [];

  static fromGrpcModel(o?: pbm.MessageSettings): MessageSettings {
    const settings = new MessageSettings();

    settings.defaultLocale = o?.defaultLocale ?? '';
    settings.enabledLocales = o?.enabledLocales ?? [];
    settings.communicationStyles = o?.communicationStyles ?? [];
    settings.communicationFlags = o?.communicationFlags ?? [];

    return settings;
  }

  static toGrpcModel(settings: MessageSettings): pbm.MessageSettings {
    return create(pbm.MessageSettingsSchema, {
      defaultLocale: settings.defaultLocale ?? '',
      enabledLocales: settings.enabledLocales ?? [],
      communicationStyles: settings.communicationStyles ?? [],
      communicationFlags: settings.communicationFlags ?? [],
    });
  }
}
